import * as v from "valibot";
import { AppError } from "./problem";

// Every success body is `{ data, meta }`. We structurally validate the envelope with
// valibot (defense-in-depth against a drifted response) and hand back the typed `data`
// and `meta`. Per-endpoint field shapes are guaranteed by the generated contract types.
const EnvelopeSchema = v.object({
  data: v.unknown(),
  meta: v.optional(v.unknown(), {})
});

export interface Envelope<D, M = unknown> {
  data: D;
  meta: M;
}

export function parseEnvelope<D, M = unknown>(body: unknown, correlationId: string): Envelope<D, M> {
  const result = v.safeParse(EnvelopeSchema, body);
  if (result.success) {
    return { data: result.output.data as D, meta: (result.output.meta ?? {}) as M };
  }
  if (body !== null && typeof body === "object" && !Array.isArray(body)) {
    return { data: body as D, meta: {} as M };
  }
  throw new AppError({
    title: "Unexpected response",
    status: 502,
    detail: "The server returned an unexpected response.",
    code: "invalid_envelope",
    correlationId
  });
}
